// @ts-nocheck

import { GridsActionTypes } from '../types/actions';
import type {
  SetPublicGridFilterType,
  SetPublicGridPageType,
  AskPublicGridsType,
  SetPublicPoolIdType,
} from '../types/actions';

export const setPublicGridFilter: SetPublicGridFilterType = (filter) => ({
  type: GridsActionTypes.SET_PUBLIC_GRID_FILTER,
  payload: { filter },
});

export const setPublicGridPage: SetPublicGridPageType = (currentPage) => ({
  type: GridsActionTypes.SET_PUBLIC_GRID_PAGE,
  payload: { currentPage },
});

export const setPublicPoolId: SetPublicPoolIdType = (poolId) => ({
  type: GridsActionTypes.SET_PUBLIC_POOL_ID,
  payload: { poolId },
});

export const askPublicGrids: AskPublicGridsType = (poolId) => ({
  type: GridsActionTypes.ASK_PUBLIC_GRIDS,
  payload: {
    poolId,
  },
});
